import styled from 'styled-components';

export const Point = styled.span`
  font-size: 40px;
`;
